/**
 * useTenantConfig — thin accessor over useAuthStore().tenant.
 *
 * Provides typed helpers so components don't need to import the full
 * TenantConfig interface or guard against null everywhere.
 */
import { useAuthStore } from '../stores/auth';

export function useTenantConfig() {
  const tenant = useAuthStore((s) => s.tenant);

  return {
    /** Raw tenant config — may be null before auth resolves. */
    tenant,

    /** Custom AI assistant name, or "Kiaan" if unset. */
    aiAssistantName: tenant?.aiAssistantName || 'Kiaan',

    /** Whether the current tenant is on the ENTERPRISE plan. */
    isEnterprise: tenant?.planTier === 'ENTERPRISE',

    /** Enabled modules list. */
    enabledModules: tenant?.enabledModules ?? null,

    /** Plan tier string. */
    planTier: tenant?.planTier ?? null,
  };
}
